export const PREFIX = 'Map/';
// export const GOOGLE_MAP_API_KEY = 'AIzaSyDVBxktCVxLu7TuKGsQeCh-VxpGu3IHHLw';
export const GOOGLE_MAP_API_KEY = 'AIzaSyAqlJVSd5wTNXHz2-IRZrJ1-dL4egDxETg';
